import API from '../../sunwiseAPI';

const ENTITY = 'report';

export const getData = (uuid) => API.get(`/api/v1/${ENTITY}/${uuid}/sunpay`);
